import React, {  useEffect, useState,useRef,useContext  } from "react";
import ReactGA from 'react-ga4';
import { useNavigate,Link,useParams  } from 'react-router-dom';
import Lang from '../../../lang/translations';
import Context from '../../../context/context';
import queryString from 'query-string';
import helpersFunction from "../../../_helpers/helpersFunction";

import trustPay_functions from "./functions";
const config = require("../../../_helpers/configServizi"); 




export default function Ok() {
    
    const query = queryString.parse(window.location.search);
    
    var InstanceId = query.instanceId

    const context = useContext(Context)
    const navigate = useNavigate() 

    /*useEffect(() => {
       
     },[])*/

    const [success, setsuccess] = useState(false);
    const [loader, setloader] = useState(false);

    

   
    
    useEffect(() => {

        const domain = window.location.hostname
        
        trustPay_functions.checkTransactionStatus({clickid:localStorage.getItem('trackerId'),InstanceId:InstanceId,domain : domain,payment_company : config.servizi[domain].payment_company})
            .then(response=>{
                if(!response.result){
                    navigate('/find')
                }
                const contenuto = helpersFunction.contenuto_popop_pagamento(response.message)
                helpersFunction.showPopupgenerico("blocked",context,contenuto)

            }).catch(err=>{
                const contenuto = helpersFunction.contenuto_popop_pagamento("generico")
                helpersFunction.showPopupgenerico("blocked",context,contenuto)
                console.log(err)
            })
           
            //setTimeout(function(){ window.location.replace("/chats")  }, 6000);
       
     },[])
    

    return (<div className="all-container bg-light pianiAbbonamentoPage">
               
            </div>
    )
   


}